import AuthBannerImage from "../Assets/IMG/auth-images/banner.png";
import LogoFull from "../Assets/IMG/logo-full.svg";
import LogoFullWhite from "../Assets/IMG/logo-full-white.svg";
import LogoM from "../Assets/IMG/logo-m.svg";
import NotFound404Image from "../Assets/IMG/not-found-404.svg";
import EmailVerifiedImage from "../Assets/IMG/auth-images/email-verified.png";
import EmailUnVerifiedImage from "../Assets/IMG/auth-images/email-unverified.png";

// BUNDLE IMAGES

// SINGLE SERVICE IMAGES
import AppleMusicImage from "../Assets/IMG/services/singles/apple_music.png";
import DuolingoImage from "../Assets/IMG/services/singles/duolingo.png";
import NetflixImage from "../Assets/IMG/services/singles/netflix.png";
import SpotifyImage from "../Assets/IMG/services/singles/spotify.png";
import YoutubeImage from "../Assets/IMG/services/singles/youtube.png";
import ShowmaxImage from "../Assets/IMG/services/singles/showmax.png";
import DeezerBlackImage from "../Assets/IMG/services/singles/deezer-black.png";
import DeezerWhiteImage from "../Assets/IMG/services/singles/deezer-white.png";
import CapCutBlackImage from "../Assets/IMG/services/singles/capcut-black.png";
import CapCutWhiteImage from "../Assets/IMG/services/singles/capcut-white.png";
import GoogleOneImage from "../Assets/IMG/services/singles/google_one.png";
import Microsoft365Image from "../Assets/IMG/services/singles/microsoft-365.png";
import iCloudAppleMusicImage from "../Assets/IMG/services/singles/iCloud-AppleMusic_Combo_Image.png";
import CrunchyrollImage from "../Assets/IMG/services/singles/crunchyroll.png";
import CanvaImage from "../Assets/IMG/services/singles/canva.png";

import { PossiblePeriods, PossibleServices } from "./Types";
export const AppName = "Manysubs";

export const BrandImages = {
  YoutubeImage: YoutubeImage,
  DuolingoImage: YoutubeImage,
  SpotifyImage: SpotifyImage,
  NetflixImage: NetflixImage,
  AppleMusicImage: AppleMusicImage,
  ShowmaxImage: ShowmaxImage,
  CapCutBlackImage: CapCutBlackImage,
  CapCutWhiteImage: CapCutWhiteImage,
  GoogleOneImage: GoogleOneImage,
  Microsoft365Image: Microsoft365Image,
  iCloudAppleMusicImage: iCloudAppleMusicImage,
  CrunchyrollImage: CrunchyrollImage,
  retrieveImage: (service: PossibleServices, theme?: "dark" | "light") => {
    // @ts-ignore
    if (service === "Apple Music") {
      return AppleMusicImage;
    } else if (service === "Netflix") {
      return NetflixImage;
    } else if (service === "YouTube Premium") {
      return YoutubeImage;
    } else if (service === "Spotify Premium") {
      return SpotifyImage;
    } else if (service === "Duolingo Super") {
      return DuolingoImage;
    } else if (service === "Showmax") {
      return ShowmaxImage;
    } else if (service === "CapCut Pro") {
      return theme === "dark" ? CapCutWhiteImage : CapCutBlackImage;
    } else if (service === "Google One") {
      return GoogleOneImage;
    } else if (service === "Deezer Premium") {
      return theme === "dark" ? DeezerWhiteImage : DeezerBlackImage;
    } else if (service === "Microsoft 365") {
      return Microsoft365Image;
    } else if (service === "iCloud - Apple Music") {
      return iCloudAppleMusicImage;
    } else if (service === "Crunchyroll") {
      return CrunchyrollImage;
    } else if (service === "Canva Pro") {
      return CanvaImage;
    }
  },
};
export const Colors = {
  BlackPrimary: "var(--black-primary)",
  BluePrimary: "var(--blue-primary)",
  BlueSecondary: "var(--blue-secondary)",

  GreenPrimary: "var(--green-primary)",
  GreenSecondary: "var(--green-secondary)",
  GreenTertiary: "var(--green-tertiary)",

  GreenLight: "var(--green-light)",
  GrayPrimary: "var(--gray-primary)",

  GrayTertiary: "var(--gray-tertiary)",
  GraySecondary: "var(--gray-secondary)",
  White: "var(--white-primary)",
  WhiteBlueTransparent: "var(--white-blue-transparent)",
  RedPrimary: "var(--red-primary)",
  OrangePrimary: "var(--orange-primary)",
  OrangeSecondary: "var(--orange-secondary)",
  Transparent: "var(--transparent)",
};

export const PurchasePeriods: { value: PossiblePeriods }[] = [
  // { value: "30 Days" },
  { value: "3 Months" },
  { value: "6 Months" },
  { value: "1 Year" },
];

export const MinimumLengthForCouponCode = 5;

export const WhatsappSupportNumber = "+2348053024713";

export {
  AuthBannerImage,
  LogoFull,
  LogoFullWhite,
  LogoM,
  EmailUnVerifiedImage,
  EmailVerifiedImage,
  NotFound404Image,
};
export const ContactInformation = {
  email: "info@manysubsng.com",
  phone: WhatsappSupportNumber,
  instagram: "manysubsng",
  telegram: "manysubsng",
};

export const SupportCategories = [
  { label: "General Support", value: "general-support" },
  { label: "Transaction Issues", value: "transaction" },
  { label: "Subscription", value: "subscription" },
  { label: "Feature Request", value: "feature-request" },
];

export const FrequentlyAskedQuestions = [
  {
    value: `What is ${AppName}?`,
    description: `${AppName} is a platform that lets you join shared subscription plans for services like Netflix, Apple Music, Spotify, Duolingo Super, and more — saving money while enjoying premium features.`,
  },
  {
    value: `How does ${AppName} work?`,
    description: `Select your desired plans and the duration. After payment, we grant you access to your chosen services, ensuring a smooth and hassle-free experience.`,
  },
  {
    value: `Is it safe to use ${AppName}?`,
    description:
      "Yes! We verify users, manage subscription access, and provide support in case of any issues to ensure a secure and seamless experience.",
  },
  {
    value: "What payment methods are supported?",
    description:
      "We accept multiple payment methods including debit cards, credit cards via Paystack",
  },
  {
    value: "Can I leave a plan anytime?",
    description:
      "You can leave after your current billing cycle ends. We ensure a fair and smooth transition when users exit a shared plan.",
  },
  {
    value: "Do I need to know other users in the plan?",
    description: `Nope! ${AppName} manages the user slots and ensures everyone gets access. You don't have to interact directly with other users.`,
  },
  {
    value: `What happens if a user misbehaves or misuses the account?`,
    description: `We monitor for unusual behavior and quickly remove any user that violates our terms. Our team ensures stability in every plan.`,
  },
  {
    value: `Do you offer refunds?`,
    description: `Refunds are handled on a case-by-case basis, typically when access hasn't been granted or an error occurred on our end. Contact support for assistance.`,
  },
  {
    value: `How do I contact support?`,
    description: `You can reach out to us through the contact form on our site or send us a direct message. We usually respond within an hour.`,
  },
  {
    value: `Can I earn money with ${AppName}?`,
    hidden: true,
    description:
      "Yes! By creating and hosting your own plan, you can fill up slots and earn as others join. We handle everything—you just sit back and manage.",
  },
];

export const SocialLinks = {
  instagramLink: "https://www.instagram.com/manysubsng",
  telegramLink: "https://t.me/manysubsng",
  homeLink: "https://manysubsng.com",
  whatsappLink: `https://wa.me/${WhatsappSupportNumber}?text=Hi!%20Please%20I%20need%20information%20concerning`,
};

export const HttpSuccessCodes: number[] = [200, 201];

export const ValidOtpLength = 6;
export const OtpWaitTime = 5;

export const PaymentsRedirectLink = "http://localhost:3000";
// export const PaymentsRedirectLink = "http://payments.theajstars.co"
